<!--
   Created by qing on 2020/2/27 3:47 下午
   Des:
-->
<template>
  <div>
    <van-cell class="ry-form__member" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          <ContactView
            v-if="(currentRow[current.dataId] && currentRow[current.dataId].member && currentRow[current.dataId].member.length)
        || (currentRow[current.dataId] && currentRow[current.dataId].depart && currentRow[current.dataId].depart.length)
        || (currentRow[current.dataId] && currentRow[current.dataId].external && currentRow[current.dataId].external.length)"
            :member="currentRow[current.dataId] ? currentRow[current.dataId].member : []"
            :depart="currentRow[current.dataId] ? currentRow[current.dataId].depart : []"
            :external="currentRow[current.dataId] ? currentRow[current.dataId].external : []">
          </ContactView>

          <div v-else class="field-empty-tips">暂无内容</div>
        </div>
        <template v-if="!isRead">
          <ContactBox
            :key="`${current.dataId}${currentRow.id}`"
            :fieldId="current.dataId"
            :uniqueId="`${current.dataId}${currentRow.id}`"
            :field="current"
            :disabled="isReadOnly"
            :user-id="$store.state.userId"
            :company-id="$store.state.companyId"
            :hasMember="current.chooseCurrentOnly === 1 ? false : hasMember"
            :hasDep="hasDep"
            :hasRole="hasRole"
            :has-ext="current.chooseCurrentOnly === 1 ? false : hasExternal"
            :has-label="hasLabel"
            :has-current="hasCurrent"
            :multiple="Boolean(current.chooseType)"
            :selectedMember="currentRow[current.dataId] ? currentRow[current.dataId].member : []"
            :selectedDep="currentRow[current.dataId] ? currentRow[current.dataId].depart : []"
            :selectedExt="currentRow[current.dataId] ? currentRow[current.dataId].external : []"
            :selectedLabel="currentRow[current.dataId] ? currentRow[current.dataId].externalTag : []"
            :availableMembers="current.chooseScope.member"
            :availableDeps="current.chooseScope.depart"
            :availableExt="current.chooseScope.external"
            :customTabs="current.type === FORM_ITEM__MEMBER ? customList : []"
            :formSet="current.type === FORM_ITEM__MEMBER ? current.root : null"
            @selectedComplete="selectedComplete"
            @change="controlChange">
          </ContactBox>
        </template>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__member-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div
            v-if="isRead">
            <ContactView
              v-if="(currentRow[current.dataId] && currentRow[current.dataId].member && currentRow[current.dataId].member.length)
        || (currentRow[current.dataId] && currentRow[current.dataId].depart && currentRow[current.dataId].depart.length)
        || (currentRow[current.dataId] && currentRow[current.dataId].external && currentRow[current.dataId].external.length)"
              :member="currentRow[current.dataId] ? currentRow[current.dataId].member : []"
              :depart="currentRow[current.dataId] ? currentRow[current.dataId].depart : []"
              :external="currentRow[current.dataId] ? currentRow[current.dataId].external : []">
            </ContactView>

            <div v-else>暂无内容</div>
          </div>
          <ContactBox
            v-if="!isRead"
            :key="`${current.dataId}${currentRow.id}`"
            :uniqueId="`${current.dataId}${currentRow.id}`"
            :fieldId="current.dataId"
            :field="current"
            :disabled="isReadOnly"
            :user-id="$store.state.userId"
            :company-id="$store.state.companyId"
            :hasMember="current.chooseCurrentOnly === 1 ? false : hasMember"
            :hasDep="hasDep"
            :hasRole="hasRole"
            :has-ext="current.chooseCurrentOnly === 1 ? false : hasExternal"
            :has-label="hasLabel"
            :has-current="hasCurrent"
            :multiple="Boolean(current.chooseType)"
            :selectedMember="currentRow[current.dataId] ? currentRow[current.dataId].member : []"
            :selectedDep="currentRow[current.dataId] ? currentRow[current.dataId].depart : []"
            :selectedExt="currentRow[current.dataId] ? currentRow[current.dataId].external : []"
            :selectedLabel="currentRow[current.dataId] ? currentRow[current.dataId].externalTag : []"
            :availableMembers="current.chooseScope.member"
            :availableDeps="current.chooseScope.depart"
            :availableExt="current.chooseScope.external"
            :customTabs="current.type === FORM_ITEM__MEMBER ? customList : []"
            :formSet="current.type === FORM_ITEM__MEMBER ? current.root : null"
            @selectedComplete="selectedComplete"
            @change="controlChange">
          </ContactBox>
        </template>
      </van-field>
    </div>
  </div>
</template>

<script>
  import ContactView from "../component/ContactView"
  import { current } from './mixin'
  import {FORM_ITEM__MEMBER, FORM_ITEM__DEPARTMENT} from "../../types";
  export default {
    mixins: [current],
    components: {
      ContactView
    },
    data () {
      return {
        FORM_ITEM__MEMBER,
        hasMember: true,
        hasRole: false,
        hasDep: false,
        hasExternal: true,
        hasLabel: false,
        hasCurrent: true,
        customList: []
      }
    },
    computed: {},
    created() {

      if (this.current.type === FORM_ITEM__MEMBER) {
        this.current.selectScope.rules.forEach(item => {
          if (item.key === 'member') {
            this.hasMember = item.memberShow === 'YES'
          } else if (item.key === 'role') {
            this.hasRole = item.memberShow === 'YES'
          } else if (item.key === 'tag') {
            this.hasLabel = item.memberShow === 'YES'
          } else if (item.key === 'ext') {
            this.hasExternal = item.memberShow === 'YES'
          } else {
            if (item.memberShow === 'YES') {
              this.customList.push({
                key: item.key,
                name: item.name
              })
            }
          }
        })
      }
    },
    methods: {
      selectedComplete(selected) {
        console.log('selected333', selected)
        let value = this.currentRow[this.current.dataId]
        value.member = selected.memberIds
        value.depart = selected.depIds
        value.external = selected.extIds
        value.externalTag = selected.labelIds
      }
    },
    watch: {}
  }
</script>